import { Helper } from "../util/helper.js";
import { General } from "../../../siteManagement/general.js";
import { ComponentHelper } from "../util/componentHelper.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { HTTPService } from "../util/httpManager.js";
import GridDataBoundEvent = kendo.ui.GridDataBoundEvent;
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class IsGrid extends React.Component<IsGridProps, any>{
    private _defined = Helper.hasValue;
    private _gridRef: any;
    private _grid: kendo.ui.Grid;
    private _searchButtonGuid;
    private _dataSourcesCache: { [field: string]: any; } = {};

    data: any;
    nextId: number;

    componentWillUnmount() {
        this._grid.destroy();
    }

    shouldComponentUpdate(nextProps, nextState) {
        let editable = nextProps.disabled ? "" : nextProps.field.gridOptions.editable;
        return (JSON.stringify(nextProps.value) !== JSON.stringify(this.data) || editable !== this._grid.options.editable);
    }

    private onDataBound = (e: GridDataBoundEvent) => {
        if (this.props.disabled) {
            // iterate the data items and apply row styles where necessary
            let dataItems = e.sender.dataSource.view();
            for (let j = 0; j < dataItems.length; j++) {
                let row = e.sender.tbody.find("[data-uid='" + dataItems[j].uid + "']");
                row.addClass("k-state-disabled");
            }
        }
    }

    componentDidUpdate() {
        this._grid.options.editable = this.props.disabled ? "" : this.props.field.gridOptions.editable
        this.data = JSON.parse(JSON.stringify(this.props.value));
        this._grid.dataSource.read();
    }

    componentDidMount() {
        let that = this;
        this.data = JSON.parse(JSON.stringify(this.props.value));
        this.nextId = this.getLatestId() + 1;

        let gridOptions: kendo.ui.GridOptions = JSON.parse(JSON.stringify(this.props.field.gridOptions));
        gridOptions = ComponentHelper.getKendoGridStandardOptions({ useColumnStateManager: true, id: "isgrid-" + this.props.field.model, initial: gridOptions });
        gridOptions.editable = this.props.disabled ? false : this.props.field.gridOptions.editable;

        if (this.props.field.searchButtonEnabled === true) {
            const toolbarItems: kendo.ui.GridToolbarItem[] = [];
            //if (!Helper.hasValue(gridOptions.toolbar))
            //    gridOptions.toolbar = [];
            if (Array.isArray(gridOptions.toolbar)) {
                gridOptions.toolbar.forEach(ti => {
                    if (typeof ti !== "string") {
                        toolbarItems.push(ti);
                    }
                });
            }

            let template: any = "<a id='{0}' class='k-button k-grid' href='\#'><span class='k-icon k-i-search'></span>{1}</a>"; //href='\\#' funktioniert an dieser Stelle nicht mehr obwohl es genauso in der Doku steht. Ist wohl ein Bug in Kendo.
            this._searchButtonGuid = kendo.guid();
            toolbarItems.push({
                template: Helper.formatString(template, this._searchButtonGuid, this.props.field.searchWindowTitle)
            });

            gridOptions.toolbar = toolbarItems;
        }

        gridOptions.dataSource = new kendo.data.DataSource({
            transport: {
                read: function (e) {
                    e.success(that.data);
                },
                create: function (e) {
                    e.data[that.props.field.schema.model.id] = that.nextId++;
                    that.data.push(e.data);
                    e.success(e.data);
                    that.props.onChange(that.props.field, JSON.parse(JSON.stringify(that.data)));
                },
                update: function (e) {
                    e.data.Dirty = true;
                    let idx = that.getIndexById(e.data[that.props.field.schema.model.id]);
                    that.data[idx] = e.data;
                    e.success();
                    that.props.onChange(that.props.field, JSON.parse(JSON.stringify(that.data)));
                },
                destroy: function (e) {
                    e.data.Delete = true;
                    let idx = that.getIndexById(e.data[that.props.field.schema.model.id]);
                    that.data.splice(idx, 1);
                    e.success();
                    that.props.onChange(that.props.field, JSON.parse(JSON.stringify(that.data)));
                }
            },
            pageSize: this.props.field.pageSize,
            schema: this.props.field.schema
        });

        gridOptions.columns = ComponentHelper.getKendoGridColumns("isgrid-" + this.props.field.model, gridOptions.columns);

        if (gridOptions.columns) {
            for (let column of gridOptions.columns) {
                if ((column as any).editor === "editor")
                    column.editor = this.editor;
            }
        }

        gridOptions.dataBound = this.onDataBound;

        this._grid = $(this._gridRef).kendoGrid(gridOptions).data("kendoGrid");

        if (this.props.field.searchButtonEnabled === true) {
            $("#" + this._searchButtonGuid).click(function (e) {
                that.openSearch();
            });
        }
    }

    editor = (container, options) => {
        let result = this.props.field.gridEditorDropDownLists ? this.props.field.gridEditorDropDownLists.filter(x => x.editField === options.field) : [];
        if (result.length > 0) {
            let dropDownList = $("<input data-bind='value:" + options.field + "'/>")
                .appendTo(container)
                .kendoDropDownList({
                    dataSource: null,
                    dataTextField: result[0].dataTextField,
                    dataValueField: result[0].dataValueField,
                    optionLabel: result[0].optionLabel,
                    template: result[0].template,
                    valuePrimitive: true,
                    autoWidth: true
                }).data("kendoDropDownList");

            let ds = this._dataSourcesCache[options.field];
            if (!this._defined(ds)) {
                HTTPService.get(result[0].dataSourceUrl)
                    .then(data => {
                        this._dataSourcesCache[options.field] = data;
                        dropDownList.setDataSource(data);
                        dropDownList.value(options.model[options.field]);
                    }
                    );
            }
            else {
                dropDownList.setDataSource(ds);
                dropDownList.value(options.model[options.field]);
            }
        }
    }

    getLatestId(): number {
        let id: number = 0;
        for (let i = 0; i < this.data.length; i++) {
            if (this.data[i][this.props.field.schema.model.id] > id)
                id = this.data[i][this.props.field.schema.model.id];
        }
        return id;
    };

    getIndexById(id: number): number {
        for (let i = 0; i < this.data.length; i++) {
            if (this.data[i][this.props.field.schema.model.id] === id)
                return i;
        }
        return -1;
    }

    mapRowToObject(obj) {
        let newObject = {};
        for (let p in this.props.field.map) {
            newObject[this.props.field.map[p]] = obj[p];
        }
        return newObject;
    }

    mapObjectToSelectedRowItem(obj) {
        let newObject = {};
        for (let p in this.props.field.map) {
            newObject[p] = obj[this.props.field.map[p]];
        }
        return newObject;
    }

    openSearch = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(this.props.field.searchWindowUrl);
        sheet.setTitle(this.props.field.searchWindowTitle);
        sheet.bind(SheetEventType.RowClicked, (e) => {
            if (typeof e === "object") {
                let newRow = this.mapRowToObject(e);
                newRow[this.props.field.schema.model.id] = this.nextId++;
                this.data.push(newRow);
                this.props.onChange(this.props.field, JSON.parse(JSON.stringify(this.data)));
                this._grid.dataSource.read();
            }
            else {
                throw new Error("IsGrid supports only fullObject mode of DynamicSearch!");
            }
        });
        sheet.bind(SheetEventType.ItemsSelected, (e) => {
            //create a new data source
            let ds = [];
            for (let i = 0; i < e.data.length; i++) {
                let newRow = this.mapRowToObject(e.data[i]);
                newRow[this.props.field.schema.model.id] = this.nextId++;
                ds.push(newRow);
            }

            this.props.onChange(this.props.field, ds);
            this._grid.dataSource.read();
        });
        let that = this;
        sheet.bind(SheetEventType.SetSelectedItems, function (callback) {
            if (that._defined(callback)) {
                let rawDS = [];
                for (var i = 0; i < that.data.length; i++) {
                    let tmp = that.mapObjectToSelectedRowItem(that.data[i]);
                    rawDS.push(tmp);
                }

                callback(rawDS);
            }
        });
    }

    render() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" ref={(r) => this._gridRef = r} style={this.props.field.style} />
            </div>
        )
    };
}
export interface IsGridProps extends BaseComponentProps {
    field: IsGridField;
}

export interface IsGridField extends BaseField {
    gridEditorDropDownLists?: Array<{ editField: string, dataSourceUrl?: string, optionLabel?: string, dataTextField: string, dataValueField: string, template?: string }>,
    gridOptions: any;
    schema: any;
    pageSize?: number;
    map?: any;
    searchButtonEnabled?: boolean;
    searchWindowTitle?: string;
    searchWindowUrl?: string
    style?: any;
}